import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
   AccountNameSearchApiResult,
   MacAddressSearchApiResult,
   PhoneNumberSearchApiResult,
   SoftphoneUsernameSearchApiResult,
} from '../models/global-search-result-api.model';
import { AccountNameResult, MacAddressResult, PhoneNumberResult, SoftphoneUsernameResult } from '../models/global-search.model';
import { GlobalSearchService } from '../services/global-search.service';
import * as GlobalSearchActions from './global-search.actions';
@Injectable()
export class GlobalSearchEffects {
   executeAccountSearch$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(GlobalSearchActions.globalSearchSearchTextChanged),
         switchMap((action) => {
            return this.globalSearchService.searchAccountNames(action.searchText).pipe(
               switchMap((response: HttpResponse<AccountNameSearchApiResult[]>) => {
                  const accounts = response.body?.map((result) => {
                     return {
                        accountId: result.accountId,
                        name: result.name,
                        shortName: result.shortName,
                     } as AccountNameResult;
                  });
                  return [GlobalSearchActions.globalSearchAccountsSearchResultSuccess({ accounts })];
               }),
               catchError((error) => {
                  return of(GlobalSearchActions.globalSearchAccountsSearchResultFailure(error));
               })
            );
         })
      );
   });

   executeDeviceSearch$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(GlobalSearchActions.globalSearchDeviceSearched),
         switchMap((action) => {
            return this.globalSearchService.searchDevices(action.searchText).pipe(
               map((response: HttpResponse<MacAddressSearchApiResult[]>) => {
                  return GlobalSearchActions.globalSearchDevicesSearchResultSuccess({
                     devices: response.body?.map((result) => {
                        return {
                           accountName: result.account.name,
                           deviceId: result.deviceId,
                           deviceType: result.deviceType,
                           macAddress: result.macAddress,
                        } as MacAddressResult;
                     }),
                  });
               }),
               catchError((error) => {
                  return of(GlobalSearchActions.globalSearchDevicesSearchResultFailure(error));
               })
            );
         })
      );
   });

   executePhoneNumberSearch$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(GlobalSearchActions.globalSearchSearchTextChanged),
         switchMap((action) => {
            return this.globalSearchService.searchPhoneNumbers(action.searchText).pipe(
               map((response: HttpResponse<PhoneNumberSearchApiResult[]>) => {
                  return GlobalSearchActions.globalSearchPhoneNumbersSearchResultSuccess({
                     phoneNumbers: response.body?.map((result) => {
                        return {
                           accountName: result.account.name,
                           phoneNumber: result.phoneNumber,
                           phoneNumberId: result.phoneNumberId,
                        } as PhoneNumberResult;
                     }),
                  });
               }),
               catchError((error) => {
                  return of(GlobalSearchActions.globalSearchPhoneNumbersSearchResultFailure(error));
               })
            );
         })
      );
   });

   executeSoftphoneUsernameSearch$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(GlobalSearchActions.globalSearchSearchTextChanged),
         switchMap((action) => {
            return this.globalSearchService.searchSoftPhoneUserNames(action.searchText).pipe(
               map((response: HttpResponse<SoftphoneUsernameSearchApiResult[]>) => {
                  return GlobalSearchActions.globalSearchSoftphoneUsernamesSearchResultSuccess({
                     softphoneUsernames: response.body?.map((result) => {
                        return {
                           accountName: result.account.name,
                           userName: result.userName,
                           extensionId: result.phone.extension.extensionId,
                           extensionNumber: result.phone.extension.number
                        } as SoftphoneUsernameResult;
                     }),
                  });
               }),
               catchError((error) => {
                  return of(GlobalSearchActions.globalSearchSoftphoneUsernamesSearchResultFailure(error));
               })
            );
         })
      );
   });

   constructor(private actions$: Actions, private globalSearchService: GlobalSearchService) {}
}
